// extracted by mini-css-extract-plugin
module.exports = {"DraggableCard":"bfb_a"};